import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReportTemplate = state => state.reportTemplate;

export const getAll = createSelector(getReportTemplate, fp.get('all'));

export const getAllValues = createSelector(
  getAll,
  fp.flow(
    fp.values,
    fp.sortBy(({ fileName }) => fileName.toLowerCase())
  )
);

export const getReportTemplatesByFileType = createSelector(
  (_, fileType) => ({ fileType }),
  getAllValues,
  fp.filter
);

export const getIsFetched = createSelector(
  getReportTemplate,
  fp.get('fetched')
);

export const getIsFetching = createSelector(
  getReportTemplate,
  fp.get('fetching')
);

export const getFetchingError = createSelector(
  getReportTemplate,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(getReportTemplate, fp.get('saving'));

export const getSavingError = createSelector(
  getReportTemplate,
  fp.get('savingError')
);

export const getIsDeleting = createSelector(
  getReportTemplate,
  fp.get('deleting')
);

export const getIsDeleted = createSelector(
  getReportTemplate,
  fp.get('deleted')
);
